export default {
  openMesh (state) {
    return state.openMesh
  }
}
